import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AcquedottiService } from '../acquedotti.service';
import { IAcquedotto } from '../acquedotti.model';
import { ACQUEDOTTI_COLUMNS } from '../acquedotti.config';
import { PageListComponent } from 'src/app/layout/pages/page-list/page-list.component';
import { KeyValueFormComponent } from 'src/app/shared/components/forms/key-value-form/key-value-form.component';

@Component({
  selector: 'app-lista-page',
  standalone: true,
  imports: [
    CommonModule,
    PageListComponent,
    KeyValueFormComponent,
  ],
  templateUrl: './lista-page.component.html',
  styleUrl: './lista-page.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListaPageComponent {
  columns = ACQUEDOTTI_COLUMNS;

  insertForm: FormGroup;

  constructor(
    private readonly fb: FormBuilder,
    public readonly service: AcquedottiService
  ) {
    this.insertForm = this.fb.group<IAcquedotto>(<IAcquedotto>{});
  }

}
